import { configureStore, combineReducers } from '@reduxjs/toolkit';

import type { Reducer, ReducersMapObject } from '@reduxjs/toolkit';

const reducers: ReducersMapObject = {};

export const store = configureStore({
  reducer: (state) => state
});

export function registerReducer (name: string, reducer: Reducer) {
  reducers[name] = reducer;
  store.replaceReducer(combineReducers(reducers));
}
